import { styled } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: `1.5px solid ${theme.palette.neutrals.beige4}`,
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.brand.mediumGreen,
    height: '2px'
  }
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  ...theme.typography.body2R,
  color: theme.palette.brand.darkGreen,
  textTransform: 'none',
  minWidth: 'auto',
  paddingLeft: '40px',
  paddingRight: '40px',
  '&.Mui-selected': {
    ...theme.typography.body2B,
    color: theme.palette.brand.mediumGreen
  },
  [theme.breakpoints.down('md')]: {
    paddingLeft: '20px',
    paddingRight: '20px'
  }
}));
